import { useEffect, useState } from 'react';
import { formsApi } from '../api/formsApi';

/** Configure email notifications for a form (internal recipients + submitter confirmation). */
export function EmailPanel({ formId }: { formId: string }) {
  const [notifyEmails, setNotifyEmails] = useState('');
  const [submitterField, setSubmitterField] = useState('');
  const [status, setStatus] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    formsApi
      .getNotifications(formId)
      .then((cfg) => {
        setNotifyEmails(cfg.notifyEmails ?? '');
        setSubmitterField(cfg.submitterEmailField ?? '');
      })
      .catch((e: unknown) => setError(e instanceof Error ? e.message : 'Failed to load notifications'));
  }, [formId]);

  async function save(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setStatus(null);
    try {
      await formsApi.updateNotifications(formId, {
        notifyEmails: notifyEmails.trim() || null,
        submitterEmailField: submitterField.trim() || null,
      });
      setStatus('Notifications saved.');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to save notifications');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="secret-links">
      <h3>Email notifications</h3>
      <p className="muted">
        On each submission we email your internal recipients and (optionally) a confirmation to
        the respondent, with the response PDF attached.
      </p>

      <form className="webhook-form" onSubmit={save}>
        <label className="field">
          Internal recipients (comma-separated)
          <input
            type="text"
            placeholder="ops@charlie-mac.com, team@charlie-mac.com"
            value={notifyEmails}
            onChange={(e) => setNotifyEmails(e.target.value)}
          />
        </label>
        <label className="field">
          Submitter email field <span className="muted">(the form field key holding the respondent's email)</span>
          <input
            type="text"
            placeholder="email"
            value={submitterField}
            onChange={(e) => setSubmitterField(e.target.value)}
          />
        </label>
        <div className="actions">
          <button type="submit" disabled={busy}>Save notifications</button>
          {status && <span className="success">{status}</span>}
          {error && <span className="error">{error}</span>}
        </div>
      </form>
    </div>
  );
}
